import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { TrainingSessionCompany } from '../../session/company/training-session-company.model';
import {
    TrainingSessionContact,
    TrainingSessionStudent,
} from '../../session/company/contact';
import { RegistrationDetail } from './registration-detail.model';
import { Observable } from 'rxjs';
import { Student } from '../../directory/student/student.model';

@Injectable()
export class RegistrationDetailService {
    isOneStudentSelected: EventEmitter<boolean> = new EventEmitter();
    areAllSelected: EventEmitter<boolean> = new EventEmitter();

    constructor(private http: HttpClient) {}

    getById(registrationDetailId): Observable<RegistrationDetail> {
        return this.http.get<RegistrationDetail>(
            '/api/registration-details/' + registrationDetailId
        );
    }

    update(
        registrationDetail: RegistrationDetail
    ): Observable<RegistrationDetail> {
        return this.http.post<RegistrationDetail>(
            '/api/registration-details/' + registrationDetail.id,
            registrationDetail
        );
    }

    delete(registrationDetailId) {
        return this.http.delete(
            '/api/registration-details/' + registrationDetailId
        );
    }

    findStudentsByPartialEmail(email: string): Observable<Student[]> {
        return this.http.get<Student[]>(`api/students/email/${email}/`);
    }

    updateRegistrationSelection(companies: TrainingSessionCompany[]): void {
        setTimeout((_) => {
            this.atLeastStudentSelected(companies);
            companies.forEach((company) => {
                this.updateRegistrationSelectionContact(company.contacts);
                company.selected = this.isElementSelected(company.contacts);
            });
            this.areAllSelected.emit(
                companies.reduce(
                    (res, company) => res && company.selected,
                    true
                )
            );
        }, 0);
    }

    getRegistrationPrice(company, registration, companies, session): string {
        if (companies && companies.length === 1) {
            if (registration.price !== 0) {
                return this.getPrice(
                    registration.price,
                    registration.priceCurrency
                );
            }

            const totalRegistration = this.getTotalCompanyRegistration(company);
            const countRegistration = this.getCountCompanyRegistration(company);
            if (totalRegistration !== 0) {
                return this.getPrice(
                    totalRegistration / countRegistration,
                    session.priceCurrency
                );
            }

            return this.getPrice(
                session.price / countRegistration,
                session.priceCurrency
            );
        }
        return this.getPrice(registration.price, registration.priceCurrency);
    }

    getPrice(amount: any, currency: string): string {
        amount = parseFloat(parseFloat(amount + '') / 100 + '').toFixed(2) + '';
        if (amount.indexOf('.00') !== -1) {
            amount = amount.substr(0, amount.length - 3);
        }
        if (currency === 'EURO') {
            return amount + ' €';
        }
        return amount + ' ' + currency;
    }

    getTotalCompanyRegistration(company: TrainingSessionCompany): number {
        return company.contacts.reduce(
            (tc, contact) =>
                tc +
                contact.students.reduce(
                    (tr, student) => (tr + student.price ? student.price : 0),
                    0
                ),
            0
        );
    }

    getCountCompanyRegistration(company: TrainingSessionCompany): number {
        return company.contacts.reduce(
            (tc, contact) => tc + contact.students.length,
            0
        );
    }

    getCompanyPrice(company): string {
        return this.getPrice(company.price, company.priceCurrency);
    }

    getCountRegistration(companies: TrainingSessionCompany[]): number {
        return companies.reduce(
            (t, company) => t + this.getCountCompanyRegistration(company),
            0
        );
    }

    private atLeastStudentSelected(companies: TrainingSessionCompany[]) {
        const contacts: TrainingSessionContact[] = [].concat.apply(
            [],
            companies.map((company) => company.contacts)
        );
        const students: TrainingSessionStudent[] = [].concat.apply(
            [],
            contacts.map((contact) => contact.students)
        );

        this.isOneStudentSelected.emit(
            students.reduce((res, student) => res || student.selected, false)
        );
    }

    private updateRegistrationSelectionContact(
        contacts: TrainingSessionContact[]
    ): void {
        contacts.forEach(
            (contact) =>
                (contact.selected = this.isElementSelected(contact.students))
        );
    }

    private isElementSelected(elements): boolean {
        return elements.reduce((res, element) => res && element.selected, true);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/registration/registration-detail/registration-detail.service.ts